import React from 'react';
import { Link } from 'react-router-dom';

import { useTags } from 'src/queries/tag';
import { TagList, Tag } from 'src/UIComponents';

function TagsList({ ...rest }) {
  const { isLoading, data: tags } = useTags({
    sort_by: ['createdAt.DESC'],
    limit: 99,
  });

  if (isLoading) {
    return null;
  }

  return (
    <TagList {...rest}>
      {tags.map((tag) => (
        <Link
          key={`tag${tag.id}`}
          to={`/tags/${tag.id}`}
          className="no-text-decoration"
        >
          <Tag color={tag.color}>{tag.title}</Tag>
        </Link>
      ))}
    </TagList>
  );
}

export default TagsList;
